import React from "react";
import "./GetQuoteButton.css";

/* ============================================================
   GET QUOTE BUTTON
   Fixed tab on the left edge, mid-height. Clicking it dispatches
   a browser event that ProductInquiryPanel listens for — this
   works even after the auto-popup has already shown once.
   ============================================================ */

const GetQuoteButton = () => {
  const handleClick = () => {
    window.dispatchEvent(new Event("open-inquiry-panel"));
  };

  return (
    <button className="gq-tab" onClick={handleClick}>
      Get Quote
    </button>
  );
};

export default GetQuoteButton;
